
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/download/value-proposition/done",
      function () {
        return require("private-next-pages/download/value-proposition/done/index.tsx");
      }
    ]);
  